/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Loader,
  Message,
  Modal,
  Icon,
  MessageHeader,
  List,
  ListItem
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
import PrecisionLevelModal from '../Modal/PrecisionLevelModal';
import WithRouter from '../Extensions/WithRouter';

class PrecisionSetting extends Component {
  constructor(props) {
    super(props);
    this.modalHeader = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isOpenMPL: false,
      isOpenAlertModal: false,
      isPopupLoading: false,
      isPageLoading: false,
      isShowCustomPrecisionLevelAllowed: false,
      precisionLevel: '',
      precisionConfig: {
        value_1: '',
        value_2: '',
      },
      defaultConfig: {
        value_1: '',
        value_2: '',
      },
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleLevelChange = this.handleLevelChange.bind(this);
    this.handleMPLModal = this.handleMPLModal.bind(this);
    this.handleCustomChange = this.handleCustomChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    if (this.state.precisionLevel !== prevState.precisionLevel && this.state.precisionLevel === 'custom') {
      this.getCustomPrecisionLevel();
    }

    if (prevState.isLoading !== isPageLoading && isPageLoading) {
      this.getCompanyPrecisionLevel();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  handleCustomChange(obj) {
    const newData = {
      value_1: obj.value_1,
      value_2: obj.value_2,
    };

    this.setState({
      isPopupLoading: true,
    }, () => {
      api
        .setCustomPrecisionLevel(newData)
        .then((response) => {
          const data = response.response;
          this.setState({
            isPopupLoading: false,
            isOpenMPL: false,
            isShowCustomPrecisionLevelAllowed: data.is_show_custom_precision_level_allowed,
            precisionConfig: obj,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isPopupLoading: false,
            isOpenMPL: false,
          });
        });
    });
  }

  handleSave() {
    const { precisionLevel, isShowCustomPrecisionLevelAllowed } = this.state;
    const { t } = this.props;

    const obj = {
      precision_level: precisionLevel,
    };

    if (precisionLevel === 'custom' && !isShowCustomPrecisionLevelAllowed) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('settings.message.custom_precision_level');
      return this.setState({
        isOpenAlertModal: true,
      });
    }

    this.setState({
      isLoading: true,
    }, () => {
      api
        .setCompanyPrecisionLevel(obj)
        .then((response) => {
          const data = response.response;
          this.setState({
            isLoading: false,
            isShowCustomPrecisionLevelAllowed: data.is_show_custom_precision_level_allowed,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  handleLevelChange(e) {
    this.setState({
      precisionLevel: e.currentTarget.dataset.id,
    });
  }

  handleMPLModal() {
    this.setState({
      isOpenMPL: true,
    });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  getCompanyPrecisionLevel() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getCompanyPrecisionLevel()
        .then((response) => {
          const data = response.response;
          this.setState({
            isShowCustomPrecisionLevelAllowed: data.is_show_custom_precision_level_allowed,
            precisionLevel: data.precision_level,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getCustomPrecisionLevel() {
    api
      .getCustomPrecisionLevel()
      .then((response) => {
        const data = response.response;
        this.setState({
          defaultConfig: data.default_precision_level_config,
          precisionConfig: data.custom_precision_level_config,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  closeModal() {
    this.setState({
      isOpenMPL: false,
      isOpenAlertModal: false,
    });
  }

  render() {
    const { state, t } = this.props;
    const {
      isLoading,
      precisionLevel,
    } = this.state;
    const { isAdmin } = state.user;

    const renderIfReady = (element) => {
      return isLoading ? (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('list.title.loading')}
        </Loader>
      ) : (
        element
      );
    };

    return (
      <div className="setting_issue_main precision" style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">{t('settings.list.precision_level_setting')}</h3>
          </div>
        </div>
        {renderIfReady(
          <div>
            <div className="setting_issues_content">
              <div className="setting_issues_content_item_wrap precision">
                <div className="user_info_item_content">
                  <div className="message_wrap">
                    <Message info>
                      <MessageHeader>{t('settings.message.confidence_level_text_0')}</MessageHeader>
                      <p>{t('settings.message.confidence_level_text_1')}</p>
                      <p>{t('settings.message.confidence_level_text_2')}</p>
                      <p>{t('settings.message.confidence_level_text_3')}</p>
                    </Message>
                  </div>
                  {
                    isAdmin ? (
                      <div
                        className="switch button_3"
                      >
                        <a
                          className={cx({
                            checked: precisionLevel.indexOf('narrow') > -1,
                          })}
                          data-id="narrow"
                          onClick={this.handleLevelChange}
                        >
                          <Icon
                            name="arrow alternate circle up"
                            color="green"
                          />
                          {t('contents_header.menu.narrow')}
                        </a>
                        <a
                          className={cx({
                            checked: precisionLevel.indexOf('medium') > -1,
                          })}
                          data-id="medium"
                          onClick={this.handleLevelChange}
                        >
                          <Icon
                            name="exchange"
                            color="blue"
                          />
                          {t('contents_header.menu.medium_precision')}
                        </a>

                        <a
                          className={cx({
                            checked: precisionLevel.indexOf('broad') > -1,
                          })}
                          data-id="broad"
                          onClick={this.handleLevelChange}
                        >
                          <Icon
                            name="arrow alternate circle down"
                            color="red"
                          />
                          {t('contents_header.menu.broad')}
                        </a>
                      </div>
                    ) : (
                      <div className="switch button_3">
                        <a
                          className={cx('disabled', {
                            checked: precisionLevel.indexOf('narrow') > -1,
                          })}
                          data-id="narrow"
                        >
                          <Icon
                            name="arrow alternate circle up"
                            color="green"
                          />
                          {t('contents_header.menu.narrow')}
                        </a>
                        <a
                          className={cx('disabled', {
                            checked: precisionLevel.indexOf('medium') > -1,
                          })}
                          data-id="medium"
                        >
                          <Icon
                            name="exchange"
                            color="blue"
                          />
                          {t('contents_header.menu.medium_precision')}
                        </a>
                        <a
                          className={cx('disabled', {
                            checked: precisionLevel.indexOf('broad') > -1,
                          })}
                          data-id="broad"
                        >
                          <Icon
                            name="arrow alternate circle down"
                            color="red"
                          />
                          {t('contents_header.menu.broad')}
                        </a>
                      </div>
                    )
                  }
                  <div className="message_wrap">
                    <Message warning>
                      {
                        precisionLevel.includes('narrow')
                        && (
                          <List bulleted>
                            <ListItem>
                              {t('settings.message.confidence_level_text_narrow_0')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_narrow_1')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_narrow_2')}
                            </ListItem>
                          </List>
                        )
                      }
                      {
                        precisionLevel.includes('medium')
                        && (
                          <List bulleted>
                            <ListItem>
                              {t('settings.message.confidence_level_text_medium_0')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_medium_1')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_medium_2')}
                            </ListItem>
                          </List>
                        )
                      }
                      {
                        precisionLevel.includes('broad')
                        && (
                          <List bulleted>
                            <ListItem>
                              {t('settings.message.confidence_level_text_broad_0')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_broad_1')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_broad_2')}
                            </ListItem>
                            <ListItem>
                              {t('settings.message.confidence_level_text_broad_3')}
                            </ListItem>
                          </List>
                        )
                      }
                    </Message>
                  </div>
                </div>
              </div>
            </div>
            {
              isAdmin ? (
                <div className="setting_issues_bottom" style={{ bottom: '-260px', position: 'absolute' }}>
                  <a className="save" onClick={this.handleSave}>{t('modal.button.save')}</a>
                </div>
              ) : null
            }
          </div>
        )}
        <PrecisionLevelModal
          isOpenMPL={this.state.isOpenMPL}
          isPopupLoading={this.state.isPopupLoading}
          precisionConfig={this.state.precisionConfig}
          defaultConfig={this.state.defaultConfig}
          isShowCustomPrecisionLevelAllowed={this.state.isShowCustomPrecisionLevelAllowed}
          onSubmit={this.handleCustomChange}
          closeModal={this.closeModal}
          translate={t}
        />
        <Modal open={this.state.isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalHeader}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a onClick={this.closeModal} className="center_button">
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(PrecisionSetting))));
